<template>
  <div class="favourites">
    <header-bar></header-bar>

    <section class="instructions background-image" v-if="!uiHideInstructions" v-show="chunkArrayLength">
      <div class="grid-container">
        <div class="col-4">
          <div class="vertical-align">
            <h3>These are all the people you've favourited. Chat now or start a conversation later.</h3>
            <a class="link-simple" @click="hideInstructions">Close</a>
          </div>
        </div>
      </div>
    </section>

    <section class="matches" v-bind:class="{ noinstructions: uiHideInstructions }" v-if="chunkArrayLength">
      <div class="grid-container">
      
        <div class="row" v-for="row in chunkArray">
          <user-box v-for="user, key in row" :userid="user" :key="key" :metadisplay="favourites"></user-box>
        </div>

      </div>
    </section>

    <section class="page-empty" v-else-if="!chunkArrayLength">
      <div class="grid-container">
        <div class="col-4 vertical-align">
          <h4>You haven't favourited anyone yet. View your <span class="bold">Matches</span> to find some interesting people.</h4>
          <router-link to="matches" class="btn btn-round green">View Matches</router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'
import UserBox from '@/components/UserBox'

export default {
  name: 'Matches',
  props: ['favourites'],
  components: {
    HeaderBar,
    UserBox
  },
  firebase: function () {
    return {
      fbUsers: {
        source: db.ref('users/'),
        asObject: true
      }
    }
  },
  computed: {
    uiHideInstructions: function () {
      if (this.$root.profile['ui-meta']) {
        if (this.$root.profile['ui-meta'].hideFavouritesInstructions) {
          return true
        }
      } else {
        return false
      }
    },
    favouritesArray: function () {
      if (!this.favourites) {
        return []
      } else {
        let arr = []
        for (let item in this.favourites) {
          arr.push(item)
        }
        return arr
      }
    },
    chunkArray: function () {
      let chunks = []
      let arr = this.favouritesArray
      if (arr) {
        let i
        let chunkSize = 4

        for (i = 0; i < arr.length; i += chunkSize) {
          chunks.push(arr.slice(i, i + chunkSize))
        }
      }
      return chunks
    },
    chunkArrayLength: function () {
      if (this.chunkArray.length) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    hideInstructions () {
      db.ref('users/' + this.$root.user.uid + '/ui-meta').update({
        hideFavouritesInstructions: true
      }, function () {
        console.log('hidden the instructions')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Favourites.vue?f9e6cc38